<template>
  <v-card>
    <v-card-title>
      {{ $t('resources._') }}

      <div class="flex-grow-1" />

      <v-btn
        text
        color="primary"
        class="mr-2"
        @click="showEditDialog()"
      >
        <v-icon left>
          add
        </v-icon>
        {{ $t('create') }}
      </v-btn>

      <import-dialog model="resources" />

      <v-text-field
        v-model="search"
        :label="$t('search')"
        prepend-inner-icon="search"
        outlined
        dense
        single-line
        hide-details
        clearable
        class="ml-2"
        @input="execSearchDebounced"
      />
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="resources.models"
      :loading="resources.loading"
      :options.sync="tableOptions"
      :server-items-length="totalDocuments"
      :no-data-text="search ? 'Sorry, no results found. Try to change the search parameters.' : 'You have no resources, create one!'"
      @update:options="loadData"
    >
      <template v-slot:item.action="{ item }">
        <span class="text-no-wrap">
          <v-icon
            small
            class="mr-2"
            @click="showEditDialog(item)"
          >
            edit
          </v-icon>

          <v-icon
            small
            @click="deleteModel(item)"
          >
            delete
          </v-icon>
        </span>
      </template>

      <template v-slot:item="{ item }">
        <tr>
          <td
            v-for="h in headers"
            :key="`cell-${h.value}`"
          >
            {{ item.$[h.value] }}
          </td>

          <td class="data-table__actions text-no-wrap">
            <v-icon
              class="mr-2"
              @click="showEditDialog(item)"
            >
              edit
            </v-icon>

            <v-icon
              color="error"
              @click="deleteModel(item)"
            >
              delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>

    <dialog-resource-form
      v-model="modelToEdit"
      :show.sync="showDialog"
    />
  </v-card>
</template>

<script>
import { BSON } from 'mongodb-stitch-browser-sdk'
import { mapGetters } from 'vuex'

import DialogResourceForm from '@/components/resources/DialogResourceForm'
import Resources from '@/models/Resources'
import Resource from '@/models/Resource'
import ImportDialog from '@/components/import/ImportDialog'
import { db } from '@/plugins/stitch'

export default {
  name: 'Resources',
  components: {
    DialogResourceForm,
    ImportDialog
  },
  data () {
    return {
      headers: [
        { text: 'Name', value: 'name', align: 'left', sortable: true }
      ],
      modelToEdit: new Resource(),
      resources: new Resources(),
      search: null,
      showDialog: false,
      tableOptions: {},
      totalDocuments: 0
    }
  },
  computed: {
    ...mapGetters('organizations', [ 'customProperties' ])
  },
  async mounted () {
    for (const prop of this.customProperties('resource')) {
      this.headers.push({
        text: prop.name,
        align: 'left',
        sortable: true,
        value: `${prop.key}`
      })
    }

    // add the action buttons as last column
    // this.headers.push({
    //   text: null,
    //   sortable: false,
    //   value: null,
    //   align: 'right'
    // })

    this.totalDocuments = await db
      .collection('resources')
      .count({ organization: this.$currentOrganization.id })
  },
  methods: {
    showEditDialog (model) {
      this.showDialog = true
      this.modelToEdit = model || new Resource({}, this.resources)
    },
    deleteModel (model) {
      model.delete()
    },
    async loadData () {
      const options = this.tableOptions
      const $match = { organization: this.$currentOrganization.id }
      const $sort = {}

      if (this.search) {
        $match.name = new BSON.BSONRegExp(this.search, 'i')
      }

      if (options.sortBy.length) {
        for (const i in options.sortBy) {
          $sort[options.sortBy[i].replace(/^\$\./, '')] = options.sortDesc[i] ? -1 : 1
        }
      } else {
        $sort.name = 1
      }

      const pipeline = [
        { $match },
        { $sort },
        { $skip: options.itemsPerPage * (options.page - 1) }
      ]

      if (options.itemsPerPage > 0) {
        pipeline.push({
          $limit: options.itemsPerPage
        })
      }

      this.resources.fetch(pipeline)
    },
    execSearchDebounced () {
      clearTimeout(this._timerId)

      this._timerId = setTimeout(this.loadData, 400)
    }
  }
}
</script>

<style lang="scss">
.data-table__actions {
  display: none;
}

tr:hover {
  td.data-table__actions {
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    background: linear-gradient(to left, rgba(128, 128, 128, 0.616) 70%, transparent);
    border: none;
  }
}
</style>
